import { render, staticRenderFns } from "./V2Input.vue?vue&type=template&id=6d146a4a&scoped=true&"
import script from "./V2Input.vue?vue&type=script&lang=js&"
export * from "./V2Input.vue?vue&type=script&lang=js&"
import style0 from "./V2Input.vue?vue&type=style&index=0&id=6d146a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d146a4a",
  null
  
)

export default component.exports